import { ChangeDetectorRef, Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, VALUE_ENTER, CODE_SPACE } from '@wizeoo/akm-core-lib';
import {
  WizBasePopUp,
  WizButton,
  WizCheckbox,
  WizDatasource,
  WizDropdown,
  WizLabel,
  WizPopUp,
  WizTextInput,
  WizVgroup,
  WizHgroup,
  WizImage,
  GridDNDConfig,
  ImageUploadParameter,
  WizEvent, WizEventManager,
  WizTranslationManager,
  WizTextarea
} from '@wizeoo/akm-component-lib';
import { GridOptions } from 'ag-grid-community';
import { ColDef } from 'ag-grid-community';
import { AngularEditorComponent, AngularEditorConfig } from '@wfpena/angular-wysiwyg';

import { of } from 'rxjs/internal/observable/of';
import { FeiKeyDef, FIELD_KIND } from '@wizeoo/akm-compute-lib';

import { WIDGET_KIND } from '../../../../model/enums';
import { ViewData } from '../../../../model/view.data';
import { ConnectVO } from '../../../../vo/core/connect.vo';
import { FreedataArgsVO } from  '../../../../vo/core/freedataargs.vo';
import { FormatVO } from '../../../../vo/workingdata/format.vo';
import { FormFieldObj } from '../../../../manager/baselines/form-field.obj';
import { GridsterWidgetItem } from '../../../../vo/workingzone/gridster-widget-item';
import { AttachmentService } from "../../../../command/core/attachment/attachment.service";
import { Model } from '../../../../model/model';
import { CssRenderVO } from '../../../../vo/workingdata/cssrender.vo';
import { WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';


/** contrat d'interface pour les données manipulée dans cette PopUp */
export interface BaselineFieldSettingsPopVO {
  model: Model;
  item: GridsterWidgetItem, 
  popReference: WizPopUp, 
  popUpMode: string, // mode de rendu, pour différencier les comportements entre FORM et TILE
  updateCallback: Function;
}


@Component({
  // popUp d'édition des champs de formulaire & tile BL: style, label, champs des FDVs
  selector: 'baseline-field-settings-pop',
  templateUrl: './baseline-field-settings.pop.html',
})
export class BaselineFieldSettingsPop extends WizBasePopUp {
  /** Zone de detail (pour updateEvent) */
  @ViewChild('vgDetailZone', { read: WizVgroup }) vgDetailZone: WizVgroup;
  @ViewChild('lbTitle', { read: WizLabel, static: false }) lbTitle: WizLabel; // titre de la popUp (fullcode)
  @ViewChild('btnSave', { read: WizButton, static: true }) btnSave: WizButton; // bt save

  @ViewChild('gpLabel', { read: WizVgroup, static: false }) gpLabel: WizVgroup; // gestion du label
    @ViewChild('tiLabel', { read: WizTextInput, static: false }) tiLabel: WizTextInput; // libellé custom
    @ViewChild('tiGrp', { read: WizTextInput, static: false }) tiGrp: WizTextInput; // groupe d'appartenance
    @ViewChild('cbShowLabel', { read: WizCheckbox }) cbShowLabel: WizCheckbox; // cb d'affichage du libellé
    
  @ViewChild('gpFormat', { read: WizHgroup, static: false }) gpFormat: WizHgroup;
    @ViewChild('ddField', { read: WizDropdown }) ddField: WizDropdown; // drop de choix du champ de label des FDVs
    @ViewChild('ddFormat', { read: WizDropdown }) ddFormat: WizDropdown; // drop de choix du formatage
    @ViewChild('ddStyle', { read: WizDropdown }) ddStyle: WizDropdown; // drop de choix du style

    @ViewChild('cbReadOnly', { read: WizCheckbox, static: true }) cbReadOnly: WizCheckbox; // col éditable en lecture seule
    @ViewChild('cbNoClone', { read: WizCheckbox, static: true }) cbNoClone: WizCheckbox; // champ non cloné
   
 
  @ViewChild('gpFields', { read: WizVgroup, static: false }) gpFields: WizVgroup; // choix du champ en cas de FD / chrono  

  @ViewChild('advancedTab', { read: WizVgroup, static: false }) advancedTab: WizVgroup; // settings pour Workflow
  @ViewChild('taSettings', { read: WizTextarea, static: false }) taSettings: WizTextarea; // settings pour Workflow

  @ViewChild('gpHhtmlEditor', { read: WizHgroup, static: false }) gpHhtmlEditor: WizHgroup;
  @ViewChild('ae') ae: AngularEditorComponent; // bt save
   
  @ViewChild('gpConnect', { read: WizVgroup, static: false }) gpConnect: WizVgroup;
    @ViewChild('ddConnect', { read: WizDropdown }) ddConnect: WizDropdown; // drop de choix du champ de la fonction
    @ViewChild('btConnect', { read: WizButton }) btConnect: WizButton; // bouton de rendu de la fonction
 
  @ViewChild('imgGp', { read: WizHgroup, static: false }) imgGp: WizHgroup; // image libre
    @ViewChild('img', { read: WizImage, static: false }) img: WizImage;
  

  htmlContent: string = '';

  /** configuration de l'editeur html */
  public editorConfig: AngularEditorConfig = {
    width: '100%',
    height: '100%',
    editable: true,
    enableToolbar: true,
    showToolbar: true,
    spellcheck: false,
    sanitize: false,
    placeholder: null,
    translate: 'no',
    defaultFontSize: '2',
    defaultParagraphSeparator: 'p',
    defaultFontName: 'calibri',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
    ],


    //imageResizeSensitivity: 0
  }

  public get model(): Model {
    return this.datas.model;
  }


  /** DS de la drop des champs de rendu pour les FDVs */
  public fieldDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFields([{ property: 'trsLabel', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS du grid des champs de sélection pour les FDVs */  
  public fieldsDS: WizDatasource<FreedataArgsVO> = new WizDatasource<FreedataArgsVO>([])
    .setSortFn(this.sortSelectedFirst.bind(this))
    .setSelectionMode('multiple')
    .build();


    public searchFields: string[] = []; // mémorisation des clés de searchField pour sort custom
    /**
     * sort custom pour placer les searchFields sélectionnés en premier
     * @param itemA 
     * @param item 
     */
    public sortSelectedFirst(itemA: FreedataArgsVO, itemB: FreedataArgsVO): number {
      // console.log('sort', itemA, itemB, this.searchFields);
      let idxOfA: number = -1;
      let idxOfB: number = -1;
      if (this.searchFields) {
        idxOfA = this.searchFields.indexOf(itemA.code) >-1 ? this.searchFields.indexOf(itemA.code) : -1;
        idxOfB = this.searchFields.indexOf(itemB.code) >-1 ? this.searchFields.indexOf(itemB.code) : -1;
      }
  
      if (idxOfA === -1) {
        idxOfA = 1000 + itemA.order;
      }
  
      if (idxOfB  === -1) {
        idxOfB = 1000 + itemB.order;
      }
  
      let result: number = 1;
      if(idxOfB - idxOfA >= 0) {
        result = -1;
      }
      // console.log('##A',idxOfA, itemA.code, "##B",idxOfB, itemB.code, "##Res", result);
      return result;
    }
  

  /** DS de la drop des formats */
  public formatDS: WizDatasource<FormatVO> = new WizDatasource<FormatVO>([])
    .setFilter(this.dataFormatFilter.bind(this))
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** DS de la drop des styles */
  public styleDS: WizDatasource<CssRenderVO> = new WizDatasource<CssRenderVO>([])
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();


  /** DS des fonctions Connect */
  public connectDS: WizDatasource<ConnectVO> = new WizDatasource<ConnectVO>()
    .setSortFields([{ property: 'code', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  // colonne du grid
  public columns: ColDef[] = [
    { headerName: '$.field.shortcode.$',dndSource: true, flex: 1, sortable: true, field: 'trsLabel' }
  ];

  gridOptions: GridOptions = {
  };

  // configuration du drag
  public dndConfig: GridDNDConfig<FreedataArgsVO> = {
    dragEnabled: true,
    dropEnabled: true,
    dropAction: 'reorder'
  };

  private doSaveFlag: boolean = true; // marqueur de validation des modifs (false sur cancel)
  public declare datas: BaselineFieldSettingsPopVO; // le contrat de données pour la pop

  public static baseHeight: number = 600; // hauteur avec tout, statique pour prise externe sur ouverture
  public static baseWidth: number = 600; // largeur, statique pour prise externe sur ouverture
  
  // taille de la zone settings pour les workflow
  private settingsHeight: number = 80;

  private realHeight: number = 600; // hauteur réelle


  public fkd: FeiKeyDef = null;
  public isFake:boolean = false; //libellé / title
  private _fakeKind: string; // type de rendu libre
  private _currentImg: string = null; // image libre en cours

  public isFD(): boolean {
    return !!this.fkd && !!this.fkd.isFreedata;
  }

  /** accesseur sur le field du WidgetItem, casté */
  public get field(): FormFieldObj {
    const field: FormFieldObj =  this.datas.item.field as FormFieldObj;
    return field;
  }

  public get context(): WidgetConfigurationItemObj {
    return this.field?.wcio;
  }

  constructor(public elementRef: ElementRef, protected cdref: ChangeDetectorRef) {
    super();
  }

  public show(): void {
    super.show();

    const buCnx: Map<string, ConnectVO> = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode);
    const cnxArr: ConnectVO[] = !!buCnx ? [...buCnx.values()] : [];
    this.connectDS.setSource(cnxArr);


    setTimeout(() => {
      this.feed(); // alimentation des données et DS
      this.addListeners();
      this.getMyRealSize();
    }, 0);
  }

  /** sur séquence de démarrage, alimentation des listes avec leurs DS */
  public feed(): void {

    /** DS de la drop des formats */
    if(!!this.model.formatEngine.getFormatList()) {
      this.formatDS.setSource(this.model.formatEngine.getFormatList());
    }

    // TODO filter à la BU
    if(!!this.model.styleEngine.getCssRenderList()) {
      this.styleDS.setSource(this.model.styleEngine.getCssRenderList());
    }

    const cod: string = this.field.wcio.cod.split(ViewData.CONTEXT_SEPARATOR)[0];
    if( cod === ViewData.FORM_HTML || 
        cod === ViewData.FORM_IMAGE || 
        cod === ViewData.FORM_ACTION ||
        cod === ViewData.FORM_ZONE) {

      this.isFake = true;
      this._fakeKind = cod;

    switch(this._fakeKind) {
      case ViewData.FORM_HTML:
        this.gpHhtmlEditor.visible = true;
        this.lbTitle.wizLabel = '$.common.free.content.$';
        this.htmlContent = this.field.wcio.lbl || null; // WizTranslationManager.getInstance().translateKey('$.common.free.content.$');
        if(this.ae) {
            // this.ae.config = this.editorConfig;
            // console.log('bsp');
            // this.ae.placeholder='';
            // this.ae.showPlaceholder = false;
            //this.ae.writeValue(this.field.wcio.lbl || WizTranslationManager.getInstance().translateKey('$.common.free.content.$'));
        }
      break;
      case ViewData.FORM_IMAGE:
        this.lbTitle.wizLabel = '$.common.free.image.$';
        this.imgGp.visible = true;
          if(!!this.field.wcio.lbl) {
            this._currentImg = this.field.wcio.lbl;
            this.img.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(this._currentImg);
          } else {
            this.img.sourceObservable = of(null);
          }
        // console.log('edit image', this.field.contextItem);
      break;
      case ViewData.FORM_ACTION:
        this.lbTitle.wizLabel = '$.common.free.action.$';
        this.gpConnect.visible = true;
        this.ddConnect.wizDataProvider = this.connectDS;

        const cnx: ConnectVO = this.model.connectMapExt?.get(this.model.domainCode)?.get(this.model.businessUnitCode)?.get(this.field.wcio.lbl);
        this.feedConnectButton(cnx);
        // console.log('edit action', this.field.contextItem);
      break;
      case ViewData.FORM_ZONE:
        this.lbTitle.wizLabel = '$.common.free.zone.$';
        this.gpLabel.visible = true;
        this.gpFormat.visible = true;
        if (!!this.context?.lbl) { // label custom  
          this.tiLabel.wizValue = this.context.lbl;
        } else {
          this.tiLabel.wizValue = WizTranslationManager.getInstance().translateKey('$.common.free.zone.$');
        }
        if (!!this.context?.pgrp) { // label du groupe
          this.tiGrp.wizValue = this.context.pgrp;
        } else {
          this.tiGrp.wizValue = '';
        }

        let style: CssRenderVO = null; // le style 
        if (this.context.sty) {
          style = this.styleDS.getItemByKey(this.context.sty);
        }
        this.styleDS.select([style]);
        this.ddStyle.wizDataProvider = this.styleDS;

        break;
      }


    } else { // champ vrai
      this.gpLabel.visible = true;
      this.gpFormat.visible = true;
      this.fkd = this.datas.item.field.fkd;
      this.lbTitle.wizLabel = this.model.feiEngine.getFeiKeyDefLabel(this.fkd); // nom réel du champ


      if (!!this.field.wcio.lbl) { // label custom
        this.tiLabel.wizValue = this.field.wcio.lbl;
      } else {
        this.tiLabel.wizValue = this.field.label;
      }

    if (!!this.context?.pgrp) { // label du groupe
      this.tiGrp.wizValue = this.context.pgrp;
    } else {
      this.tiGrp.wizValue = '';
    }

      this.cbReadOnly.wizChecked = this.field?.wcio?.ro;
      this.cbNoClone.wizChecked = this.field?.wcio?.noc;
      this.cbShowLabel.wizChecked = this.field.wcio.slbl;

      // gestion du format
      this.formatDS.refresh(); // actualisation de la drop des formats
      let format: FormatVO = null; // le format de données
      let formatSplit: string[] = null;
      if (this.datas.item.format) {
        formatSplit = this.datas.item.format.split(ViewData.KEY_SEPARATOR);
        format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
      } else if (!!this.datas?.item?.field?.fkd?.defaultFormat) {
        formatSplit = this.datas?.item?.field?.fkd?.defaultFormat.split(ViewData.KEY_SEPARATOR);
        format = this.model.formatEngine.getFormat(formatSplit[0], formatSplit[1]);
      }
      this.formatDS.select([format]);
      this.ddFormat.wizDataProvider = this.formatDS;

      let style: CssRenderVO = null; // le style 
      if (this.context.sty) {
        style = this.styleDS.getItemByKey(this.context.sty);
      }
      this.styleDS.select([style]);
      this.ddStyle.wizDataProvider = this.styleDS;

      if(this.fkd.datakind === FIELD_KIND.WORKFLOW) {
        this.advancedTab.visible = true;
        this.taSettings.wizValue = this.context.pmdexParams;
      }


      if (this.fkd.isFreedata) { // c'est un FD ou un chrono, on affiche le choix du champ et le grid
        // this.gpField.visible = true;
        this.ddField.visible = true;
        if(this.datas.popUpMode === WIDGET_KIND.FORM) {
          this.gpFields.visible = true;
        }
        
        // on collecte le bon FD
        const args: FreedataArgsVO[] = this.model.freedataEngine.getArgsFromFD(this.fkd.code);
        this.fieldDS.setSource([...args]);
        this.fieldsDS.setSource([...args]);
        this.ddField.wizDataProvider = this.fieldDS;

        if (!!this.field.wcio.fdvf) { // prendre obj.field.wcio.fdvf
          this.fieldDS.select([this.fieldDS.getItemByKey(this.field.wcio.fdvf)]);
        }

        if (!!this.field.wcio.fdvSearch) { // champs sélectionné pour rendu des pops de sélection
          this.searchFields = this.field.wcio.fdvSearch.split(ViewData.KEY_SEPARATOR);

          // const vals: string[] = this.field.wcio.fdvSearch.split(ViewData.KEY_SEPARATOR);
          const valArgs: FreedataArgsVO[] = this.searchFields.map(item => this.fieldsDS.getItemByKey(item));
          // console.log('valargs', valArgs);
          this.fieldsDS.select(valArgs);
          this.fieldsDS.doSort(this.fieldsDS.getSource()); // on ré-applique le tri
        } 
      }
      // TODO TODO autoriser chrono
      // else if (this.fkd.isChrono) { 
      //   // this.gpField.visible = true;
      //   this.ddField.visible = true;
      //   this.gpFields.visible = true;
      // }
      else {
        this.realHeight = 300;
        if(this.fkd.datakind === FIELD_KIND.WORKFLOW) {
        this.realHeight += this.settingsHeight;
        }
      }
    }

  }

  /** mise en place des écouteurs */
  public addListeners(): void {
    // écouteur global change pour modelUpdate
    WizEventManager.addListener(this, this.vgDetailZone, WIZ_EVENT_TYPE.MODEL_UPDATE, this.updateModel);
  }

  /**
   * Modification du model dans la zone de saisie
   * @param e Evenement model change
   */
  private updateModel(e: WizEvent): void {
    // console.log('updateModel', e.value, this.datas.argData.arg.datas);
    switch (e.component) {
      case this.ddConnect: {
        const cnx: ConnectVO = this.ddConnect.selectedItem;
        this.feedConnectButton(cnx);
        break;
      }
    }
  }

  /* ##############################################################################
                   sauvegarde
     ############################################################################## */

  /** Sauvegarde */
  public save(): void {
    this.hide();
  }

  /** annulation des modifs */
  public doCancel(): void {
    this.doSaveFlag = false;
    this.hide();
  }

  /** sur hide, tentative d'enregistrement */
  public onHide() {
    if (this.doSaveFlag) {

      if(this.isFake) {
        switch(this._fakeKind) {
          case ViewData.FORM_HTML:
            let chtemeleu = this.htmlContent ;//this.ae.editHistory.pop();
            // let chtemeleu = this.ae.editorWrapper.nativeElement.innerHTML;
            this.field.wcio.lbl = chtemeleu;
          break;
          case ViewData.FORM_IMAGE:
            this.field.wcio.lbl = this._currentImg;
          break;
          case ViewData.FORM_ACTION:
            const connect: ConnectVO = this.connectDS.selectedItem;
            const connectCode: string = connect ? connect.code : null;
            this.field.wcio.lbl = connectCode;
          break;
          case ViewData.FORM_ZONE:
            this.field.wcio.lbl = this.tiLabel.wizValue;
            this.field.wcio.pgrp = this.tiGrp.wizValue;
            const style: CssRenderVO = this.styleDS.selectedItem;
            this.field.wcio.sty = style?.code || null;
          break;
        }
      } else { // champ du FDV
        let fdvf: string = null;
        if (this.fieldDS.selectedItem) {
          fdvf = this.fieldDS.selectedItem.code;
        } 
  
        let fdvSearch: string = null;
        if (this.fieldsDS.selectedItems) {
          const parts: Set<string> = new Set(this.fieldsDS.selectedItems.map(item => item.code));
          const orderedParts: string[] = []; // on les prend dans le bon ordre
          this.fieldsDS.getWorkedSource().forEach((arg: FreedataArgsVO) => {
            if(parts.has(arg.code)) {
              orderedParts.push(arg.code);
            }
          });
  
          // console.log('parts', parts, orderedParts);
          fdvSearch = orderedParts.join(ViewData.KEY_SEPARATOR);
        }
  
  
        this.field.wcio.lbl = this.tiLabel.wizValue;
        this.field.wcio.pgrp = this.tiGrp.wizValue;

        this.field.wcio.slbl = this.cbShowLabel.wizChecked;
        this.field.wcio.fdvf = fdvf;
        this.field.wcio.fdvSearch = fdvSearch;
        this.field.wcio.ro = this.cbReadOnly.wizChecked;
        this.field.wcio.noc = this.cbNoClone.wizChecked;
        // gestion du format
        const format: FormatVO = this.formatDS.selectedItem;
        const formatCode: string = format ? format.businessUnitCode + ViewData.KEY_SEPARATOR + format.code : null;
        this.field.wcio.fmt = formatCode;

        const style: CssRenderVO = this.styleDS.selectedItem;
        const styleCode: string = style?.code || null;
        this.field.wcio.sty = styleCode;

        this.field.wcio.pmdexParams = this.taSettings.wizValue;

      }

      // console.log("oks", this.tiLabel.wizValue, fdvf, fdvSearch);
      this.datas.updateCallback(this.datas);
    }
  }

  /** définition de la bonne taille */
  private getMyRealSize(): void {
    if (this.realHeight !== BaselineFieldSettingsPop.baseHeight) {
      this.datas.popReference.dialogRef.updateSize(BaselineFieldSettingsPop.baseWidth + 'px', this.realHeight + 'px');
    }
  }

  /**
   * filterFunc de la liste des formats, selon le type de la données
   * @param e la fonction
   */
  public dataFormatFilter(fm: FormatVO): boolean {
    if (!this.datas?.item?.field?.fkd?.datakind) {
      return false;
    }
    // if (!this.datas.pivotField.pkd || !this.datas.pivotField.pkd.dataKind) {
    //   return false;
    // }
    return fm.dataKind === this.datas?.item?.field?.fkd?.datakind;
  }


  /** feed initial ou refresh sur une fonction connect libre */
  private feedConnectButton(cnx: ConnectVO): void {
    if (!!cnx) {
      this.btConnect.wizLabel = cnx.trsLabel;
      this.btConnect.tooltipText = cnx.trsDescription;
      this.btConnect.wizImage = cnx.iconOrDie;
    } else {
      this.btConnect.wizLabel = '$.connect.unknow.$';
      this.btConnect.tooltipText = '$.connect.unknow.$';
      this.btConnect.wizImage = AttachmentService.getInstance().iconOrDie(null, this.model.domainCode, this.model.businessUnitCode, ViewData.wildcardMainVision);
    }
  }

  /**
   * Demande de chargement d'une image
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public clickForUpload(): void {

    let params: ImageUploadParameter = {
      component: this.img,
      elementRef: this.img.elementRef,
      dom: this.model.domainCode,
      bu: this.model.businessUnitCode,
      vision: ViewData.wildcardMainVision,
      viewCallback: this.uploadCallback.bind(this)
    }
    this.model.batchEngine.loadImage(params);
  }

  /**
   * demande d'ouverture sur l'image picker par clavier; touche entrée ou espace
   * @param event event clavier
   * @param target FD pour l'icone du FD, FDV pour l'icone d'un FDV
   */
  public keydownForUpload(event: KeyboardEvent): void {
    const isEnterKey = event.key === VALUE_ENTER; // touche entrée
    const isSpaceKey = event.code === CODE_SPACE; // touche espace
    if (isEnterKey || isSpaceKey) {
      this.clickForUpload();
    }
  }

  /**
   * Callback de l'upload d'image sur FD
   * @param files Le fichier
   * @param fileStr byte[] au format String
   */
  private uploadCallback(blobId: string): void {
    if (blobId) {
      this._currentImg = blobId;
      this.img.sourceObservable = AttachmentService.getInstance().downloadAttachmentForWidget(blobId);
    } else {
      this.img.sourceObservable = of(null);
    }
  }
}
